<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <div class="card-header-title">
                            <span class="mdi mdi-text-box-check-outline mr-2 text-muted"></span> 
                            Vendor Checklist
                        </div>
                    </div>
                    <div class="col">
                        <button class="btn btn-primary btn-sm float-right" @click="openChecklistItemCreate">
                            <span class="mdi mdi-plus"></span> Add Checklist Item
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <p style="font-size: 1.1em;">
                    The following items will appear on the check-list sent to vendor when a new job is booked
                </p>
            </div>
        </div>

        <div class="card mt-3" v-for="(item, idx) in checklistItems" :key="item.item_id">
            <div class="card-body">
                <div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Display Text</label>
                                <textarea class="form-control" type="text" rows="2" v-model="item.display_text"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <label>Response Type</label>
                                <select class="form-control" v-model="item.input_type" :disabled="item.display_only">
                                    <option value="text">Text Entry</option>
                                    <option value="bool">Yes/No</option>
                                    <option value="select">Dropdown List/Wheel</option>
                                </select>
                            </div>
                        </div>
                        <!-- <div class="col-4">
                            <div class="form-group">
                                <label>Display Order</label>
                                <input type="text" class="form-control" v-model="item.display_order">
                            </div>
                        </div> -->
                        <div class="col-4">
                            <div class="form-group">
                                <label>Display Only? (Non-input)</label>
                                <div class="mt-2">
                                    <label class="switch mr-1">
                                        <input type="checkbox" v-model="item.display_only">
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="item.input_type == 'select'">
                        <div class="col">
                            <label>Response Options</label>
                            <p>
                                <span class="mdi mdi-information-outline"></span>
                                This field only affects items with response type Dropdown List/Wheel. Seperate values with a comma
                            </p>
                            <input type="text" class="form-control" v-model="item.strSelectOptions">
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-footer">
                <div class="row">
                    <div class="col">
                        <span class="mdi mdi-loading mdi-24px mdi-spin" v-if="item.isSaving"></span>
                    </div>
                    <div class="col">
                        <div class="float-right">
                            <button class="btn btn-danger btn-sm mr-2" @click="confirmDelete(item, idx)">
                                <span class="mdi mdi-trash-can-outline"></span> Delete Item
                            </button>
                            <button class="btn btn-primary btn-sm" @click="saveItemChanges(item, idx)">
                                <span class="mdi mdi-content-save"></span> Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
        <!-- Create New Item Modal -->
        <b-modal 
            id="modal-create-checklist-item"
            modal-ok
            title="Create Vendor Checklist Item"
            no-close-on-backdrop
            ok-title="Save"
            @ok="onCreateModalOK">
            <div v-if="newItem">
                <div class="form-group">
                    <label>Display Text</label>
                    <textarea class="form-control" rows="3" v-model="newItem.display_text" id="tbNewItemText"></textarea>
                </div>

                <div class="form-group">
                    <label title="Use this option to just display text to the vendor, e.g. an instruction/request">
                        Display Only? <span class="mdi mdi-information-outline ml-1" ></span>
                    </label>
                    <label class="switch ml-2 mr-1">
                        <input type="checkbox" v-model="newItem.display_only">
                        <span class="slider round"></span>
                    </label>
                </div>

                <div v-if="!newItem.display_only">
                    <div class="form-group">
                        <label>Response Type</label>
                        <select class="form-control" v-model="newItem.input_type" :disabled="newItem.display_only">
                            <option value="text">Text Entry</option>
                            <option value="bool">Yes/No</option>
                            <option value="select">Dropdown List/Wheel</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="newItem.input_type == 'select'">
                        <label>Response Options</label>
                        <p>
                            <span class="mdi mdi-information-outline"></span>
                            This field only affects items with response type Dropdown List/Wheel. Seperate values with a comma
                        </p>
                        <input type="text" class="form-control" v-model="newItem.strSelectOptions">
                    </div>
                </div>
            </div>
        </b-modal>
        <!-- /Create New Item Modal -->
        
        <!-- Loading info -->
        <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
            <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
        </div>
        <!-- /Loading info -->

        <div v-if="viewState == 'Error'">
            <div class="alert alert-danger">
                Something went wrong loading your data, please try again. 
                If the problem persists, please contact the support team.
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                viewState: 'Idle',
                checklistItems: [],
                newItem: null,
                isSavingNewItem: false
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                let res = await axios.get('/api/vendorchecklist/templates')
                this.checklistItems = res.data.map(i => {
                    return {
                        strSelectOptions: i.select_options.join(', '),
                        ...i
                    }
                })
                this.viewState = 'Idle'
            } catch (error) {
                this.viewState = 'Error'
                this.error = error                
            }
        },
        methods: {
            async saveItemChanges(item, idx) {
                try {
                    if (item.input_type == 'select' && item.strSelectOptions) {
                        item.select_options = item.strSelectOptions.split(',').map(str => str.trim())
                    }

                    let saveResponse = await axios.put(`/api/vendorchecklist/templates/${item.item_id}`, item)
                    this.$bvToast.toast(`Checklist Item Saved`, {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (error) {
                    console.error(error)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t save the checklist item', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            async deleteItem(item, idx) {
                try {
                    await axios.delete(`/api/vendorchecklist/templates/${item.item_id}`)
                    this.$delete(this.checklistItems, idx)
                    this.$bvToast.toast('Checklist Item deleted', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                } catch (error) {
                    console.error(error)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t delete this Item', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            async onCreateModalOK(evt) {
                evt.preventDefault()
                try {
                    if (this.newItem.input_type == 'select' && this.newItem.strSelectOptions) {
                        this.newItem.select_options = this.newItem.strSelectOptions.split(',').map(str => str.trim())
                    }

                    let createResult = await axios.post('/api/vendorchecklist/templates', this.newItem)                    
                    this.checklistItems.push({
                        ...createResult.data,
                        strSelectOptions: createResult.data.select_options.join(', ')
                    })

                    this.$bvToast.toast('Checklist Item Created', {
                        title: 'Success',
                        variant: 'success',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })

                    this.$bvModal.hide('modal-create-checklist-item')
                    this.newItem = null

                } catch (error) {
                    console.error(error)
                    this.$bvToast.toast('Sorry, something went wrong and we couldn\'t create a new Checklist Item', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true,
                        appendToast: true,
                        autoHideDelay: 3000
                    })
                }
            },
            confirmDelete(item, idx) {
                let msg = 'Are you sure you wish to delete this item?'
                this.$bvModal
                    .msgBoxConfirm(msg, { centered: true })
                    .then(confirm => {
                        if (confirm) {
                            this.deleteItem(item, idx)
                        }
                    })
            },
            openChecklistItemCreate() {
                this.newItem = { input_type: 'text' }
                this.$bvModal.show('modal-create-checklist-item')
                this.$nextTick().then(v => document.getElementById('tbNewItemText').focus())
            },
            arrayToCommaSeparatedString(array) {
                return array ? array.join(', ') : ''
            }
        }
    }
</script>